export * from "./colors";
export * from "./enums";
export * from "./fonts";
export * from "./styles";

export const API_HOST = process.env.REACT_APP_API_HOST || "";
export const AI_HOST = process.env.REACT_APP_AI_HOST || "";

export const defaultErrorMessage =
  "Something went wrong. Please try again later.";
